"use client";

import { Route as UnknownRoute } from "@faire/web/ui/routing/Route";
import React from "react";

import { SuppliersRouter } from "@faire/retailer/views/suppliers/SuppliersRouter";

export const RenderSuppliersRoutes = () => {
  return <UnknownRoute path="/suppliers" component={SuppliersRouter} />;
};
